<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <v-row>
      <v-col cols="12">
        <v-autocomplete v-model="statusTarefaSelecionada" :items="listaStatusTarefa" label="Filtrar por Status:" autocomplete="off" clearable></v-autocomplete>
      </v-col>
    </v-row>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Tarefas'"
      :tableHeader="headers"
      :tableRows="tarefasDoAgente"
      :isView="true"
      :isReport="true"
      :isHistorico="true"
      :isTarefa="true"
      :totalItens="total"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
      v-on:datatable-viewrow="visualizarTarefaSelecionada"
      v-on:datatable-report="abrirModalGerarRelatorio"
      v-on:datatable-finishrow="concluirTarefa"
      v-on:datatable-historicotarefa="abrirModalHistoricoTarefa"
    ></DataTable>

    <SkeletonTable v-show="showSkeletonTable == true" :showSkeletonTable="showSkeletonTable"></SkeletonTable>

    <div>
      <v-dialog v-model="dialog" persistent width="1200">
        <v-card color="#3c8dbc" dark>
          <v-card-title>
            <v-row justify="center">
              <v-col class="text-h5 text-bold" cols="auto">
                Por favor aguarde um momento...
              </v-col>
            </v-row>

            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-title>
        </v-card>
      </v-dialog>
    </div>

    <ModalCustomSize
      :modalSize="modalCustomSizeData.modalSize"
      :isTheModalOpen="modalCustomSizeData.isOpen"
      :modalButtonText="modalCustomSizeData.buttonText"
      :modalFormTitle="modalCustomSizeData.formTitle"
      :modalType="modalCustomSizeData.modalType"
      :isLoadingRequestDisable="modalCustomSizeData.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSizeData.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSizeData.isButtonsDisabled"
      :isTarefa="true"
      v-on:formmodal-close="modalCustomSizeData.isOpen = false"
      v-on:formmodal-action="gerarRelatorio"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field v-model="modalCustomSizeData.actualEdit.razaoSocial" name="razaoSocial" label="Empresa" autocomplete="off" readonly />
        </v-col>

        <v-col cols="6">
          <v-text-field v-model="modalCustomSizeData.actualEdit.nomeResponsavel" name="responsavel" label="Responsável" autocomplete="off" readonly />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-text-field v-model="modalCustomSizeData.actualEdit.cnpj" name="cnpj" label="CNPJ" autocomplete="off" readonly />
        </v-col>

        <v-col cols="6">
          <v-text-field v-model="modalCustomSizeData.actualEdit.cevs" name="cevs" label="CEVS" autocomplete="off" readonly />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-text-field v-model="modalCustomSizeData.actualEdit.endereco" name="endereco" label="Endereço" autocomplete="off" readonly />
        </v-col>

        <v-col cols="6">
          <v-text-field v-model="modalCustomSizeData.actualEdit.bairro" name="bairro" label="Bairro" autocomplete="off" readonly />
        </v-col>
      </v-row>
      <v-btn @click="baixarFotos()" depressed>
        Baixar Fotos
      </v-btn>

      <!-- Informações tarefa -->
      <v-row>
        <v-col cols="12">
          <v-list v-if="modalCustomSizeData.isEdit">
            <v-list-item>
              <v-list-item-action>
                <v-checkbox v-model="todosSelecionado" @click="selecionaTodos"></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Listar todos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-for="(setor, i) in modalCustomSizeData.actualEdit.listaSetores" :key="i">
              <v-list-item-action>
                <v-checkbox v-model="modalCustomSizeData.actualEdit.listaDeSetoresParaGerar" :value="setor" @click="seleciona"></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ setor.setor.nomeSetor }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-list v-else>
            <v-list-group v-for="(setor, i) in modalCustomSizeData.actualEdit.listaSetores" :key="i" no-action sub-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ setor.setor.nomeSetor }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item v-for="(questao, j) in setor.listaQuestaoSetor" :key="j">
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12">
                      <v-subheader> Questão {{ j + 1 }} </v-subheader>
                      <v-divider />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-col cols="12">
                        <v-textarea v-model="questao.questao.nomeQuestao" name="nomeQuestao" label="Questão" rows="4" row-height="30" autocomplete="off" readonly />
                      </v-col>

                      <v-col cols="12">
                        <v-text-field v-model="questao.questao.descricaoQuestao" name="descricaoQuestao" label="Lei" autocomplete="off" readonly />
                      </v-col>

                      <v-col cols="12">
                        <v-textarea v-model="questao.respostaQuestao.observacao" name="descricaoObservacao" label="Observação" autocomplete="off" rows="3" row-height="20" readonly />
                      </v-col>

                      <v-col v-if="questao.fotos && questao.fotos.length > 0" cols="12">
                        <v-row>
                          <v-col v-for="(foto, l) in questao.fotos" :key="l" class="d-flex child-flex" cols="3">
                            <img v-img :src="'data:image/jpeg;base64,' + foto.caminhoFoto" :lazy-src="'data:image/jpeg;base64,' + foto.caminhoFoto" width="100" height="150" style="object-fit: cover;" class="white lighten-2" />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-col>

                    <v-col v-if="questao.listaAlternativa.length > 0" cols="5">
                      <v-row cols="12" align="center" v-for="(alternativa, k) in questao.listaAlternativa" :key="k">
                        <v-col v-if="alternativa.alternativa.tipoAlternativa == 0" cols="12">
                          <v-radio-group v-model="questao.respostaQuestao.descricaoResposta">
                            <v-radio :value="alternativa.alternativa.nomeAlternativa" :label="alternativa.alternativa.nomeAlternativa" :name="questao.respostaQuestao.descricaoResposta" readonly />
                          </v-radio-group>
                        </v-col>

                        <v-col v-if="alternativa.alternativa.tipoAlternativa == 1" cols="12">
                          <v-checkbox v-model="alternativa.respostaAlternativa.descricaoResposta" :label="alternativa.alternativa.nomeAlternativa" :true-value="alternativa.respostaAlternativa.descricaoResposta" :name="questao.questao.nomeQuestao" readonly />
                        </v-col>

                        <v-col v-if="alternativa.alternativa.tipoAlternativa == 2" cols="12">
                          <v-text-field v-model="alternativa.respostaAlternativa.descricaoResposta" autocomplete="off" :label="alternativa.alternativa.nomeAlternativa" :name="questao.questao.nomeQuestao" readonly />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-col>
      </v-row>
    </ModalCustomSize>

    <ModalCustomSize
      :modalSize="modalHistoricoTarefa.modalSize"
      :modalFormTitle="modalHistoricoTarefa.formTitle"
      :isTheModalOpen="modalHistoricoTarefa.isOpen"
      :modalButtonText="modalHistoricoTarefa.buttonText"
      :isLoadingRequestDisable="modalHistoricoTarefa.isLoadingRequestDisable"
      :isModalButtonVisible="modalHistoricoTarefa.isButtonsVisible"
      :isModalButtonDisabled="modalHistoricoTarefa.isButtonsDisabled"
      v-on:formmodal-close="modalHistoricoTarefa.isOpen = false"
    >
      <v-form v-model="estaValido">
        <v-row>
          <v-col cols="12">
            <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" lg="6" md="6">
            <v-text-field v-model="modalHistoricoTarefa.formulario.nomeHistorico" name="nomeHistorico" label="Nome Historico" autocomplete="off" :rules="[rules.requerido]"></v-text-field>
          </v-col>

          <v-col cols="12" lg="6" md="6">
            <v-menu ref="menuDataCriacao" v-model="menuDataCriacao" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="formataDataCriacao" label="Data de Criação" persistent-hint v-bind="attrs" @blur="date = parseDate(formataDataCriacao)" v-on="on" autocomplete="off" :rules="[rules.data]" v-mask="['##/##/####']"></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title @input="menuDataCriacao = false"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" lg="12" md="12">
            <v-text-field v-model="modalHistoricoTarefa.formulario.descricaoHistorico" name="descricaoHistorico" label="Descrição Historico" autocomplete="off" :rules="[rules.requerido]"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" lg="12" md="12">
            <v-btn :disabled="btnAdicionar" color="blue lighten-4" @click="inserirHistoricoTarefa(modalHistoricoTarefa.formulario)">ADICIONAR </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" lg="12" md="12">
            <DataTable :tableTitle="'Lista de Historicos Tarefa'" :tableHeader="headersHistoricoTarefa" :tableRows="listaHistoricoTarefa" :isRemove="true" v-on:datatable-removerow="abrirModalDeletar"></DataTable>
          </v-col>
        </v-row>
      </v-form>

      <DeleteItemModal v-on:response-button-delete="deletarHistoricoTarefa(modalDeletar.itemSelecionado)" :showModalDelete="modalDeletar.mostrar" :textModalDelete="modalDeletar.texto" v-on:response-closebutton="modalDeletar.mostrar = false"></DeleteItemModal>
    </ModalCustomSize>

    <!-- Fazer uma outra modal ou fazer de forma responsiva para gerar um relatorio -->
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import DataTable from "@/components/DataTable2.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import SkeletonTable from "../components/SkeletonTable";
import { Document, Packer, Paragraph, ShadingType, TextRun, Header, AlignmentType, PageNumber, BorderStyle, WidthType } from "docx";
import * as fs from "file-saver";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import DeleteItemModal from "../components/DeleteItemModal";
import JsZip from "jszip";
export default {
  components: {
    DataTable,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    AlertasModal,
    DeleteItemModal,
  },

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },

  watch: {
    date(val) {
      this.formataDataCriacao = this.formatDate(this.date);
      this.modalHistoricoTarefa.formulario.dataCriacao = val;
    },

    estaValido() {
      this.btnAdicionar = !this.estaValido;
    },

    statusTarefaSelecionada() {
      this.inicializar();
    },
  },

  data: () => ({
    //Paginação
    page: 1,
    search: null,
    total: null,
    //Fim da paginação

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    rowPosition: 0,

    showSkeletonTable: true,
    todosSelecionado: false,
    dialog: false,

    //RULES
    rules: {
      requerido: (value) => value != null || "Requer o campo!",
      data: (v) => (v && v.length == 10) || "Data Incorreta",
    },

    //VALIDA FORMULARIO MODAL HISTORICO TAREFA
    estaValido: false,
    btnAdicionar: false,

    //ModalDeletar
    modalDeletar: {
      mostrar: false,
      texto: null,
      itemSelecionado: [],
    },

    //DatePicker
    date: null,
    formataDataCriacao: null,
    menuDataCriacao: false,

    //Headers
    headers: [
      {
        text: "ID",
        value: "tarefa.numeroTarefa",
      },
      {
        text: "Roteiro",
        value: "roteiro.nomeRoteiro",
      },
      {
        text: "Data Criação",
        value: "tarefa.dataTarefa",
      },
      {
        text: "Data Conclusão",
        value: "tarefa.dataConclusaoTarefa",
      },
      {
        text: "Status",
        value: "tarefa.statusTarefa",
      },
      {
        text: "Tipo",
        value: "tarefa.tipoTarefa",
      },
      {
        text: "Empresa",
        value: "empresa.nomeFantasia",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],
    headersHistoricoTarefa: [
      {
        text: "ID",
        value: "numeroHistoricoTarefa",
      },
      {
        text: "Descrição Historico",
        value: "descricaoHistorico",
      },
      {
        text: "Data Criação",
        value: "dataCriacao",
      },
      {
        text: "Nome Historico",
        value: "nomeHistorico",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    //Modal Visualizar
    modalCustomSizeData: {
      modalSize: "1500",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: null,
      isButtonsDisabled: null,
      isLoadingRequestDisable: false,
      actualEdit: {
        razaoSocial: null,
        nomeFantasia: null,
        nomeResponsavel: null,
        cnpj: null,
        cevs: null,
        endereco: null,
        bairro: null,
        nomeRoteiro: null,
        descricaoRoteiro: null,
        testemunhasTarefa: [],
        listaSetores: [],
        listaDeSetoresParaGerar: [],
        descricaoTela: "tarefasAgente",
      },
    },

    //Modal Historico da Tarefa
    modalHistoricoTarefa: {
      modalSize: "1500",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: null,
      isButtonsDisabled: null,
      isLoadingRequestDisable: false,
      formulario: {
        numeroHistoricoTarefa: null,
        numeroTarefaRoteiro: null,
        descricaoHistorico: null,
        dataCriacao: null,
        nomeHistorico: null,
        caminhoAnexo: null,
      },
    },

    listaHistoricoTarefa: [],
    tarefasDoAgente: [],

    statusTarefaSelecionada: null,
    listaStatusTarefa: [
      {
        text: "Em Andamento",
        value: 0,
      },
      {
        text: "Concluída",
        value: 1,
      },
      {
        text: "Adiado",
        value: 2,
      },
      {
        text: "Processo Aberto",
        value: 4,
      },
      {
        text: "Concluída",
        value: 3,
      },
      {
          text: "Concluída com Atraso",
          value: 5
      }
    ],
  }),

  created() {
    this.inicializar();
  },

  methods: {
    async inicializar() {
      try {
        const reponseTarefas = await axios.put("tarefaAgente", { statusTarefa: this.statusTarefaSelecionada, numeroUsuario: this.$store.getters.numeroUsuario, page: this.page, search: this.search }, this.config);
        if (!reponseTarefas.data || reponseTarefas.data.length > 0) {
          this.tarefasDoAgente = reponseTarefas.data;
          this.total = reponseTarefas.data[0].total;
        }
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.showSkeletonTable = false;
      }
    },

    async updateSearch(search) {
      if (search) {
        this.search = search;
        this.page = 1;
        await this.inicializar();
      } else {
        this.page = 1;
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page;
      await this.inicializar();
    },

    async concluirTarefa(tarefa) {
      this.dialog = true;
      try {
        await axios.put("tarefas", { statusTarefa: 3, numeroTarefa: tarefa.tarefa.numeroTarefa }, this.config);
        await this.inicializar();
      } catch (error) {
        this.alerta.texto = "Tarefa não pode ser concluida";
        this.alerta.tipo = "erro";
      } finally {
        this.dialog = false;
      }
    },
    //#region FORMATAR DATA
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formataDataBanco(data) {
      if (data) {
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);

        return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
      } else {
        return null;
      }
    },

    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    //#endregion

    //#region DOCUMENTO
    gerarRelatorio() {
      const bordaParagrafo = {
        top: {
          color: "auto",
          space: 1,
          style: BorderStyle.SINGLE,
          size: 1,
          type: WidthType.DXA,
        },
        bottom: {
          color: "auto",
          space: 1,
          style: BorderStyle.SINGLE,
          size: 1,
          type: WidthType.DXA,
        },
        left: {
          color: "auto",
          space: 1,
          style: BorderStyle.SINGLE,
          size: 1,
          type: WidthType.DXA,
        },
        right: {
          color: "auto",
          space: 1,
          style: BorderStyle.SINGLE,
          size: 1,
          type: WidthType.DXA,
        },
      };

      let corpoDocx = {
        sections: [
          {
            properties: {
              titlePage: true,
            },
            headers: {
              default: new Header({
                children: [
                  new Paragraph({
                    alignment: AlignmentType.CENTER,
                    children: [new TextRun({ text: this.formatDate(new Date().toISOString().substr(0, 10)), bold: true }), new TextRun({ children: ["\t\t\t\t\t\t\t\t\t\tPág. ", PageNumber.CURRENT], bold: true })],
                    shading: {
                      type: ShadingType.REVERSE_DIAGONAL_STRIPE,
                      color: "dadfe1",
                      fill: "dadfe1",
                    },
                  }),
                ],
              }),
            },
            children: [
              new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [new TextRun({ text: this.formatDate(new Date().toISOString().substr(0, 10)), bold: true }), new TextRun({ text: "\t\t\tFICHA DE PROCEDIMENTO\t\t\t\t", bold: true }), new TextRun({ children: ["Pág. ", PageNumber.CURRENT], bold: true })],
                shading: {
                  type: ShadingType.HORIZONTAL_CROSS,
                  color: "dadfe1",
                  fill: "dadfe1",
                },
                spacing: {
                  after: 90,
                },
              }),

              //#region ESTABELECIMENTO
              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: [new TextRun({ text: "IDENTIFICAÇÃO DO ESTABELECIMENTO", bold: true })],
                shading: {
                  type: ShadingType.HORIZONTAL_CROSS,
                  color: "dadfe1",
                  fill: "dadfe1",
                },
                spacing: {
                  before: 30,
                  after: 30,
                },
              }),
              new Paragraph({
                children: [
                  new TextRun({ text: "CNPJ/CPF: " }),
                  new TextRun({ text: this.modalCustomSizeData.actualEdit.cnpj ? this.modalCustomSizeData.actualEdit.cnpj : "", allCaps: true, size: 24, type: WidthType.DXA }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "Número de Cadastro - CEVS: " }),
                  new TextRun({ text: this.modalCustomSizeData.actualEdit.cevs ? this.modalCustomSizeData.actualEdit.cevs : "", allCaps: true, size: 24, type: WidthType.DXA }),
                ],
                spacing: {
                  after: 10,
                },
              }),
              new Paragraph({
                children: [new TextRun({ text: "Razão Social / Nome: " }), new TextRun({ text: this.modalCustomSizeData.actualEdit.razaoSocial ? this.modalCustomSizeData.actualEdit.razaoSocial : "", allCaps: true, size: 24, type: WidthType.DXA })],
                spacing: {
                  after: 60,
                },
              }),

              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: [new TextRun({ text: "ENDEREÇO DO ESTABELECIMENTO", bold: true })],
                shading: {
                  type: ShadingType.HORIZONTAL_CROSS,
                  color: "dadfe1",
                  fill: "dadfe1",
                },
                spacing: {
                  before: 30,
                  after: 30,
                },
              }),
              new Paragraph({
                children: [new TextRun({ text: "Logradouro, No: " }), new TextRun({ text: this.modalCustomSizeData.actualEdit.endereco ? this.modalCustomSizeData.actualEdit.endereco : "", allCaps: true, size: 24, type: WidthType.DXA })],
                spacing: {
                  after: 10,
                },
              }),
              new Paragraph({
                children: [new TextRun({ text: "Bairro: " }), new TextRun({ text: this.modalCustomSizeData.actualEdit.bairro ? this.modalCustomSizeData.actualEdit.bairro : "", allCaps: true, size: 24, type: WidthType.DXA }), new TextRun({ text: "\t" }), new TextRun({ text: "Município / UF: " })],
                spacing: {
                  after: 10,
                },
              }),
              new Paragraph({
                children: [
                  new TextRun({ text: "Telefone: " }),
                  new TextRun({ text: this.modalCustomSizeData.actualEdit.telefoneEmpresa ? this.modalCustomSizeData.actualEdit.telefoneEmpresa : "", allCaps: true, size: 24, type: WidthType.DXA }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "Fax: " }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "E-mail: " }),
                  new TextRun({ text: this.modalCustomSizeData.actualEdit.emailEmpresa ? this.modalCustomSizeData.actualEdit.emailEmpresa : "", allCaps: true, size: 24, type: WidthType.DXA }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "CEP: " }),
                  new TextRun({ text: this.modalCustomSizeData.actualEdit.cepEndereco ? this.modalCustomSizeData.actualEdit.cepEndereco : null, allCaps: true, size: 24, type: WidthType.DXA }),
                ],
                spacing: {
                  after: 60,
                },
              }),
              //#endregion

              //#region CARACTERIZAÇÃO DO PROCEDIMENTO
              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: [new TextRun({ text: "CARACTERIZAÇÃO DO PROCEDIMENTO", bold: true })],
                shading: {
                  type: ShadingType.HORIZONTAL_CROSS,
                  color: "dadfe1",
                  fill: "dadfe1",
                },
                spacing: {
                  before: 30,
                  after: 30,
                },
              }),
              new Paragraph({
                children: [
                  new TextRun({ text: "Origem do Procedimento: " }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "Início (Data): " }),
                  new TextRun({ text: this.modalCustomSizeData.actualEdit.dataInicio ? this.modalCustomSizeData.actualEdit.dataInicio : "", allCaps: true, size: 24, type: WidthType.DXA }),
                  new TextRun({ text: "\t" }),
                  new TextRun({ text: "Fim (Data): " }),
                  new TextRun({ text: this.modalCustomSizeData.actualEdit.dataFim ? this.modalCustomSizeData.actualEdit.dataFim : "", allCaps: true, size: 24, type: WidthType.DXA }),
                ],
                spacing: {
                  after: 30,
                },
              }),
              new Paragraph({
                text: "- Objetivo: ",
                spacing: {
                  after: 10,
                },
                border: bordaParagrafo,
              }),
              new Paragraph({ text: "" }),
              new Paragraph({ text: "" }),
              new Paragraph({
                text: "",
                spacing: {
                  after: 10,
                },
              }),
              new Paragraph({
                text: "- Relato da situação: ",
                spacing: {
                  after: 10,
                },
                border: bordaParagrafo,
              }),
              //#endregion
            ],
          },
        ],
      };

      this.modalCustomSizeData.actualEdit.listaDeSetoresParaGerar.map((setores) => {
        let numeroSetor = 1;
        corpoDocx.sections[0].children.push(
          new Paragraph({
            alignment: AlignmentType.LEFT,
            children: [new TextRun({ text: "Setor " + numeroSetor + ":\t", bold: true }), new TextRun({ text: setores.setor.nomeSetor, bold: true, allCaps: true, size: 24, type: WidthType.DXA })],
            shading: {
              type: ShadingType.HORIZONTAL_CROSS,
              color: "dadfe1",
              fill: "dadfe1",
            },
            spacing: {
              before: 60,
              after: 60,
            },
          })
        );

        let numeroQuestao = 1;
        setores.listaQuestaoSetor.map((questoes) => {
          corpoDocx.sections[0].children.push(
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [new TextRun({ text: "Questão " + numeroQuestao + ": ", bold: true }), new TextRun({ text: questoes.questao.nomeQuestao, size: 24, type: WidthType.DXA })],
              spacing: {
                before: 60,
                after: 30,
              },
            })
          );

          questoes.listaAlternativa.map((alternativas) => {
            if (alternativas.alternativa.tipoAlternativa == 0) {
              if (alternativas.alternativa.nomeAlternativa === questoes.respostaQuestao.descricaoResposta) {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: "(X) " + alternativas.alternativa.nomeAlternativa, bold: true, size: 24, type: WidthType.DXA })],
                  })
                );
              } else {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: "( ) " + alternativas.alternativa.nomeAlternativa, size: 22, type: WidthType.DXA })],
                  })
                );
              }
            }

            if (alternativas.alternativa.tipoAlternativa == 1) {
              if (alternativas.respostaAlternativa.descricaoResposta) {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: "[X] " + alternativas.alternativa.nomeAlternativa, bold: true, size: 24, type: WidthType.DXA })],
                  })
                );
              } else {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: "[ ] " + alternativas.alternativa.nomeAlternativa, size: 22, type: WidthType.DXA })],
                  })
                );
              }
            }

            if (alternativas.alternativa.tipoAlternativa == 2) {
              if (alternativas.respostaAlternativa.descricaoResposta) {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: alternativas.alternativa.nomeAlternativa + " " + alternativas.respostaAlternativa.descricaoResposta, size: 24, type: WidthType.DXA })],
                  })
                );
              } else {
                corpoDocx.sections[0].children.push(
                  new Paragraph({
                    alignment: AlignmentType.LEFT,
                    children: [new TextRun({ text: alternativas.alternativa.nomeAlternativa, size: 22, type: WidthType.DXA })],
                  })
                );
              }
            }
          });

          corpoDocx.sections[0].children.push(
            new Paragraph({
              alignment: AlignmentType.LEFT,
              children: [new TextRun({ text: questoes.respostaQuestao.observacao ? "Observação: " + questoes.respostaQuestao.observacao : "", size: 24, type: WidthType.DXA })],
              spacing: {
                after: 60,
              },
            })
          );

          numeroQuestao++;
        });

        numeroSetor++;
      });

      Packer.toBlob(new Document(corpoDocx)).then((blob) => {
        fs.saveAs(blob, this.modalCustomSizeData.actualEdit.razaoSocial + ".docx");
      });
    },
    //#endregion

    async baixarFotos() {
      var zip = new JsZip();
      this.modalCustomSizeData.actualEdit.listaSetores.map((setor) => {
        setor.listaQuestaoSetor.map((questao) => {
          questao.fotos.map((foto) => {
            zip.file("Setor: " + setor.setor.nomeSetor + " - Questão: " + questao.questao.nomeQuestao + " - Número" + foto.numeroFotoQuestao + ".jpg", foto.caminhoFoto, { base64: true });
          });
        });
      });

      zip.generateAsync({ type: "blob" }).then((content) => {
        fs.saveAs(content, "Tarefa - " + this.modalCustomSizeData.actualEdit.razaoSocial + ".zip");
      });
    },

    async visualizarTarefaSelecionada(tarefaSelecionada) {
      try {
        this.alertaModal.tipo = null;

        this.dialog = true;
        let tarefaRespondida = await axios.put("tarefaRespondida", tarefaSelecionada.tarefa, this.config);

        this.modalCustomSizeData.actualEdit.razaoSocial = tarefaRespondida.data.empresa.razaoSocial;
        this.modalCustomSizeData.actualEdit.nomeFantasia = tarefaRespondida.data.empresa.nomeFantasia;
        this.modalCustomSizeData.actualEdit.nomeResponsavel = tarefaRespondida.data.endereco.nomeResponsavel;
        this.modalCustomSizeData.actualEdit.cnpj = tarefaRespondida.data.empresa.cnpj;
        this.modalCustomSizeData.actualEdit.cevs = tarefaRespondida.data.endereco.cevs;
        this.modalCustomSizeData.actualEdit.endereco = tarefaRespondida.data.endereco.endereco;
        this.modalCustomSizeData.actualEdit.bairro = tarefaRespondida.data.endereco.bairro;
        this.modalCustomSizeData.actualEdit.nomeRoteiro = tarefaRespondida.data.roteiro.nomeRoteiro;
        this.modalCustomSizeData.actualEdit.descricaoRoteiro = tarefaRespondida.data.roteiro.descricaoRoteiro;
        this.modalCustomSizeData.actualEdit.listaSetores = tarefaRespondida.data.listaSetores;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.dialog = false;
      } finally {
        this.modalCustomSizeData.isOpen = true;
        this.modalCustomSizeData.isEdit = false;
        this.modalCustomSizeData.isView = true;
        this.modalCustomSizeData.isButtonsVisible = false;
        this.modalCustomSizeData.formTitle = "Visualizar Tarefa";

        this.dialog = false;
      }
    },

    async abrirModalGerarRelatorio(tarefaSelecionada) {
      try {
        this.alertaModal.tipo = null;

        this.dialog = true;

        let tarefaRespondida = await axios.put("tarefaRespondida", tarefaSelecionada.tarefa, this.config);

        this.modalCustomSizeData.actualEdit.telefoneEmpresa = tarefaSelecionada.empresa.telefone;
        this.modalCustomSizeData.actualEdit.emailEmpresa = tarefaSelecionada.empresa.email;
        this.modalCustomSizeData.actualEdit.cepEndereco = tarefaSelecionada.endereco.cep;
        this.modalCustomSizeData.actualEdit.dataInicio = this.formatDate(this.formataDataBanco(tarefaRespondida.data.tarefa.dataCriacaoTarefa));
        this.modalCustomSizeData.actualEdit.dataFim = this.formatDate(this.formataDataBanco(tarefaRespondida.data.tarefa.dataConclusaoTarefa));

        this.modalCustomSizeData.actualEdit.razaoSocial = tarefaRespondida.data.empresa.razaoSocial;
        this.modalCustomSizeData.actualEdit.nomeFantasia = tarefaRespondida.data.empresa.nomeFantasia;
        this.modalCustomSizeData.actualEdit.nomeResponsavel = tarefaRespondida.data.endereco.nomeResponsavel;
        this.modalCustomSizeData.actualEdit.cnpj = tarefaRespondida.data.empresa.cnpj;
        this.modalCustomSizeData.actualEdit.cevs = tarefaRespondida.data.endereco.cevs;
        this.modalCustomSizeData.actualEdit.endereco = tarefaRespondida.data.endereco.endereco;
        this.modalCustomSizeData.actualEdit.bairro = tarefaRespondida.data.endereco.bairro;
        this.modalCustomSizeData.actualEdit.nomeRoteiro = tarefaRespondida.data.roteiro.nomeRoteiro;
        this.modalCustomSizeData.actualEdit.descricaoRoteiro = tarefaRespondida.data.roteiro.descricaoRoteiro;
        this.modalCustomSizeData.actualEdit.listaSetores = tarefaRespondida.data.listaSetores;
        this.modalCustomSizeData.actualEdit.listaDeSetoresParaGerar = [];
        this.modalCustomSizeData.actualEdit.testemunhasTarefa = tarefaSelecionada.testemunhaTarefa;
        this.todosSelecionado = false;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.dialog = false;
      } finally {
        this.modalCustomSizeData.isOpen = true;
        this.modalCustomSizeData.isEdit = true;
        this.modalCustomSizeData.isView = false;
        this.modalCustomSizeData.isButtonsVisible = true;
        this.modalCustomSizeData.buttonText = "Gerar";
        this.modalCustomSizeData.formTitle = "Gerar Relatório de Tarefa";

        this.dialog = false;
      }
    },

    async abrirModalHistoricoTarefa(tarefaSelecionada) {
      this.modalHistoricoTarefa.isOpen = true;
      this.modalHistoricoTarefa.formTitle = "Historico da Tarefa";
      this.modalHistoricoTarefa.isButtonsVisible = false;

      this.modalHistoricoTarefa.formulario.numeroTarefaRoteiro = tarefaSelecionada.tarefa.numeroTarefa;
      this.btnAdicionar = !this.estaValido;

      this.listarHistoricoTarefa(this.modalHistoricoTarefa.formulario.numeroTarefaRoteiro);

      this.modalHistoricoTarefa.formulario.descricaoHistorico = null;
      this.modalHistoricoTarefa.formulario.dataCriacao = null;
      this.modalHistoricoTarefa.formulario.nomeHistorico = null;
    },

    async inserirHistoricoTarefa(historicoTarefa) {
      try {
        await axios.put("historicoTarefa", historicoTarefa, this.config);

        this.modalHistoricoTarefa.formulario.descricaoHistorico = null;
        this.modalHistoricoTarefa.formulario.dataCriacao = null;
        this.modalHistoricoTarefa.formulario.nomeHistorico = null;
        this.date = null;
        this.listarHistoricoTarefa(this.modalHistoricoTarefa.formulario.numeroTarefaRoteiro);
      } catch (error) {
        console.log(error);
      }
    },

    async listarHistoricoTarefa(tarefa) {
      try {
        let response = await axios.put("listarHistoricoTarefa", { numeroTarefaRoteiro: tarefa }, this.config);
        this.listaHistoricoTarefa = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async deletarHistoricoTarefa(historicoTarefa) {
      try {
        await axios.delete("historicoTarefa", { data: historicoTarefa, headers: this.config.headers });
        this.listarHistoricoTarefa(this.modalHistoricoTarefa.formulario.numeroTarefaRoteiro);
        this.modalDeletar.mostrar = false;
      } catch (error) {
        console.log(error);
      }
    },

    abrirModalDeletar(item) {
      this.modalDeletar.itemSelecionado = item;
      this.modalDeletar.mostrar = true;
      this.modalDeletar.texto = "Deseja realmente excluir esse Historico da Tarefa?";
    },

    seleciona() {
      this.todosSelecionado = false;
    },

    selecionaTodos() {
      this.modalCustomSizeData.actualEdit.listaDeSetoresParaGerar = [];

      if (this.todosSelecionado) {
        this.modalCustomSizeData.actualEdit.listaDeSetoresParaGerar = this.modalCustomSizeData.actualEdit.listaSetores;
      }
    },
  },
};
</script>
